export default __webpack_public_path__ + "static/media/aggregateSample.28b86f97.xlsx";